<template>
    <div id="app" class="bg">
        
        <b-navbar toggleable="lg" type="dark" variant="primary" >
            <b-navbar-brand href="#">
                <b-icon icon="diamond-half"></b-icon> {{ $t('HomePage.appname') }}
            </b-navbar-brand>
    
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown right>
                               
                                <template #button-content>
                                    ພາສາ
</template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

        <b-nav-item @click="exit()">
          <b-icon icon="power" aria-hidden="true" variant="light"></b-icon>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <b-row  >


      <b-col class="mt-2 mb-4 " align-v="stretch">
        
             <router-view  />
         
       
      </b-col>

    </b-row>




  </div>
</template>

<script>
//import axios from "axios";
export default {
    created() {
        // axios.get(this.$store.getters.getBaseUrl + "/getMenu/0000").then((rep) => {
        //     this.menus = rep.data;
        // });
    },

    data() {
        return {
            menus: [],
            submenu: [],
            user:[]
        }
    },
    methods: {
        exit() {
            localStorage.removeItem("Login");
            this.$router.push("/login");
        },
        settop() {
            document.body.scrollTop = 0
        }
    },

}
</script>

<style>
#app {
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100vh;
    background-color: #ffffff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50vh;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #021f3b;
}

#nav a.router-link-exact-active {
    color: #42b983;
}

.bgtopbar {
    background-color: #023c7e
}

.bg {
    background-color: #ffffff;
}
.header {
  height: 88px;
  background-color: #FFFFFF;
}
</style>
